import { APIGet, IAPIResponse } from "api/protocols";
import { CancelToken } from "axios";
import { ITournament } from "redux/reducers/models/tournament";

const apiVersion = "2024-04";
const adminType = "customer";
const baseTournamentUrl = "/" + apiVersion + "/" + adminType + "/tournament";

interface IGetTournament {
  id?: number;
  facility_id?: number;
  handle?: string;
  year?: number;
  month?: number;
  timeframe?: "upcoming" | "past";
  offset?: number;
  limit?: number;
  search?: string;
}

export async function GetCustomerTournament(
  params: IGetTournament,
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IAPIResponse<Array<ITournament>>> {
  return await APIGet(baseTournamentUrl, params, useGlobalLoader, token);
}
